var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-dropzone"},[_c('vue-dropzone',{ref:"dropzone",staticClass:"ui-dropzone__area",class:[{ 'ui-dropzone__area--error': _vm.error }, { 'ui-dropzone__area--disabled': _vm.disabled }],attrs:{"id":"dropzone","options":_vm.options,"useCustomSlot":_vm.showCustomSlot},on:{"vdropzone-file-added":_vm.handleFileAdded,"vdropzone-removed-file":_vm.handleFileRemoved}},[(_vm.showCustomSlot)?_c('div',{staticClass:"ui-dropzone__custom-slot"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/public/forms/fields/Dropzone.vue?vue&type=template&id=79dc8868&
// module id = 1131
// module chunks = 0